<template>
    <div>
        <modal class="add-nickname" :class="{'no-close': noClose}" :display="modalStatus.addNickName" @modalStatus="closeModal" >
            <h1>請輸入出租人姓名</h1>
            <div class="add-nickname-wrap">
                <div class="content">
                    <div class="nickname-input">
                        <label for="">出租人姓名</label>
                        <div class="input-error-group">
                            <input :class="{error: nickNameErr}" type="text" v-model="nickName" placeholder="請輸入出租人姓名">
                            <span v-show="nickNameErr" class="error">{{nickNameErr}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="setNickName()">確定</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'

import { 
    apiSetNickName
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            nickName: '',
            nickNameErr: '',
        }
    },
    props: {
        noClose: Boolean,
    },
    watch: {
        nickName: function (val) {
            this.checkInput()
        },
        // 'modalStatus.addNickName': function (val) {
        //     console.log(val)
        //     if(val){
        //         this.$analytics.logEvent('新增出租人姓名', { screen_name: '新增出租人姓名'})
        //     }
        // }
    },
    methods: {
        setNickName: function () {
            this.$analytics.logEvent('送出出租人姓名', { screen_name: '送出出租人姓名'})
            
            if(this.checkInput()){
                apiSetNickName(this.nickName)
                .then(res => {
                    if( res.data.status == "SUCCESS" ){
                        this.$store.dispatch('getUserStatus')
                        this.closeModal()
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            }
        },
        checkInput: function () {
            if(this.nickName){
                this.nickNameErr = ''
                return true
            }else{
                this.nickNameErr = '請輸入出租人姓名'
                return false
            }
        },
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'addNickName'})
        },
    },
    computed: {
        isOpen: function () {
            if(this.value){
                return '開啟'
            }else{
                return '關閉'
            }
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.add-nickname{
        .error{
            right: 0px;
            top: -24px;
            left: unset;
        }
        .modal-content{
            width: 448px;
            height: 333px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 42px;
                }
                .add-nickname-wrap{
                    padding: 0 32px 0 32px;
                    .content{
                        label{
                            margin-bottom: 12px;
                            display: block;
                        }
                        .nickname-input{
                            width: 384px;
                            margin-bottom: 70px;
                            input{
                                width: 349px;
                            }
                        }
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 384px;
                    height: 44px;
                }
            }
        }
    }
    #modal.no-close{
        .cancle{
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/addNickName.vue